<template>
    <div class="input-group" :style="fieldStyles()">
      <field-icon :fieldData="fieldData"></field-icon>

      <div :ref="fieldData.field_name"
        :id="fieldData.field_name"
        :name="fieldData.field_name"
        v-bind:class="{
          'vgs-field': true,
          'error': errors.has(fieldData.field_name)  || fieldData.has_error
        }">
        <span :id="vgsName" class="vgs-span"></span>
      </div>
      <i v-bind:class="{'warning fas fa-exclamation-triangle': errors.has(fieldData.field_name)  || fieldData.has_error }"></i>
    </div>
</template>

<script>
/* eslint-disable */
import FieldIcon from '../presentational/FieldIcon';
import { inputFieldMixin } from '../../mixins/inputFieldMixin';

export default {
  inject: ['$validator'], // Allows this component's validation messages to appear in other components
  props: ['fieldData', 'inputType', 'vgsStatus'],
  components: { FieldIcon },
  mixins: [inputFieldMixin],
  data() {
    return {
      fieldValue: '',
      hasError: false,
      vgsName: `credit_card_${this.fieldData.field_name}`,
      targetId: `#credit_card_${this.fieldData.field_name}`,
      fieldSettings: {
        type: 'card-number',
        name: `fields[${this.vgsStatus.indexes.QTE_CreditCardNumber}].field_value`,
        successColor: '#4F8A10',
        errorColor: '#D8000C',
        placeholder: 'XXXX XXXX XXXX XXXX',
        validations: ['required', 'validCardNumber'],
        showCardIcon: {
          left: '175px',
          top: '16.5px',
        },
        css: {
          'color': '#1b1d1f',
          'height': '27px',
          'width': 'inherit',
          'font-size': '0.75rem',
          'padding': '0px',
          'margin': '3px',
          'box-sizing': 'border-box',
          'font-family': '"Open Sans", sans-serif',
          'background-clip': 'padding-box',
          'border': '1px solid #CCCCCC',
          'border-radius': '3.333px',
          'padding': '2.5px 6.66px',
          'transition': 'border-color 0.15s ease-in-out,box-shadow 0.15s ease-in-out,-webkit-box-shadow 0.15s ease-in-out',
          '::placeholder': {
            'color': '#999',
          },
          '&:focus': {
            'color': '#5c6873',
            'background-color': '#fff',
            'border-color': '#8ad4ee',
            'outline': '0',
            '-webkit-box-shadow': '0 0 0 0.2rem rgba(32,168,216,0.25)',
            'box-shadow': '0 0 0 0.2rem rgba(32,168,216,0.25)',
          },
        },
      },
    };
  },
  mounted() {
    this.getfieldSettingsName();
    this.vgsStatus.active[this.vgsName] = this.fieldData.visible;

    if (this.vgsStatus.isVgsFormReady) {
      this.$nextTick(function () {
         const flowType = sessionStorage.getItem('flowType');
        if (flowType === "bundle" && Object.keys(this.vgsStatus.indexes).includes('QTE_PRP_CreditCardNumber')) {
          this.$root.$emit("load-cc-home", this.targetId, this.fieldSettings, this.vgsName);
        } else {
          this.$root.$emit("load-cc", this.targetId, this.fieldSettings, this.vgsName);
        }
      })
    }
  },
  methods:{
   getfieldSettingsName()
    { 
    if(Object.keys(this.vgsStatus.indexes).includes('QTE_PRP_CreditCardNumber'))
     this.fieldSettings.name=`fields[${this.vgsStatus.indexes.QTE_PRP_CreditCardNumber}].field_value`;
    else
     this.fieldSettings.name=`fields[${this.vgsStatus.indexes.QTE_CreditCardNumber}].field_value`;
    return this.fieldSettings;
   }
  },
  watch: {
    "fieldData.visible": function (newValue) {
      this.vgsStatus.active[this.vgsName] = newValue;
    },
    "vgsStatus.isVgsFormReady": function (newValue) {
      if (newValue === true) {
        const flowType = sessionStorage.getItem('flowType');
        if (flowType === "bundle" && Object.keys(this.vgsStatus.indexes).includes('QTE_PRP_CreditCardNumber')) {
          this.$root.$emit("load-cc-home", this.targetId, this.fieldSettings, this.vgsName);
        } else {
        this.$root.$emit("load-cc", this.targetId, this.fieldSettings, this.vgsName);
      }
          
      }
    },
  },
  beforeDestroy() {
    this.vgsStatus.active[this.vgsName] = false;
    if (this.vgsStatus.hasLoaded[this.vgsName]) {
      this.vgsStatus.hasLoaded[this.vgsName].delete();
    }
    this.vgsStatus.hasLoaded[this.vgsName] = false;
  }
};
/*
      this.vgsForm.field();
*/
</script>

<style scoped>
.vgs-field {
  height: 27px;
}
.card-type {
  width: 400px;
}
#credit_card {
    position: relative;
    left: -3px;
    top: -3px;
}
.vgs-hidden-token {
  display: none;
}
.cctest-button {
  position: relative;
  top: -156px;
  left: 300px;
}
</style>



// WEBPACK FOOTER //
// src/components/interactive/InputVgsCreditcard.vue?27bd0640